// https://websitesetup.org/web-safe-fonts-html-css/
export const FONTS = [
  'Arial',
  'Times New Roman',
  'Tahoma ',
  'Trebuchet MS',
  'Courier',
  'Verdana',
  'Georgia',
  'Palatino',
  'Comic Sans MS',
  'Arial Black',
  'Impact',
];